import { GET_COMPANY_DETAILS } from "resources/actionTypes";

const initialCompanyDetailsState = {
  companyDetails: [],
  loading: false,
  error: null,
};

export const userCompanyDetails = (state = initialCompanyDetailsState, action) => {
  switch (action.type) {
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetails: action.companyProfile,
        loading: false,
      };
    case GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};